export const authConstants = {
  TOKEN_KEY: 'token',
  USER_NAME: 'userName',
  USER: 'user',
  USERID:'userId',
  TOOLTIP:'toolTipStatus'
}
